import { create } from "zustand";
import { persist } from "zustand/middleware";

type CookieConsent = {
  analytics: boolean;
  necessary: boolean;
  marketing: boolean;
};

type CookieState = {
  consent: CookieConsent | null;
  isModalOpen: boolean;
};

type CookieActions = {
  setConsent: (consent: CookieConsent) => void;
  setModalOpen: (isOpen: boolean) => void;
  acceptAll: () => void;
  rejectAll: () => void;
  acceptSelected: (consent: Partial<CookieConsent>) => void;
};

export const useCookieStore = create<CookieState & CookieActions>()(
  persist(
    (set) => ({
      consent: null,
      isModalOpen: false,
      setConsent: (consent) => set({ consent }),
      setModalOpen: (isModalOpen) => set({ isModalOpen }),
      acceptAll: () =>
        set({
          consent: {
            analytics: true,
            necessary: true,
            marketing: true,
          },
          isModalOpen: false,
        }),
      rejectAll: () =>
        set({
          consent: {
            analytics: false,
            necessary: true, // Necessary cookies are always required
            marketing: false,
          },
          isModalOpen: false,
        }),
      acceptSelected: (consent) =>
        set((state) => ({
          consent: {
            analytics: false,
            marketing: false,
            ...state.consent,
            ...consent,
            necessary: true, // Necessary cookies are always required
          },
          isModalOpen: false,
        })),
    }),
    {
      name: "cookie-consent",
      partialize: (state) => ({ consent: state.consent }),
    }
  )
); 